import { Category } from '../../types';
import { Button } from '../base/Button';

interface CategoryListProps {
  categories: Category[];
  onEditCategory: (category: Category) => void;
  onDeleteCategory: (categoryId: string) => void;
}

export const CategoryList = ({ categories, onEditCategory, onDeleteCategory }: CategoryListProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Categories</h2>
      </div>
      
      <div className="p-4">
        <div className="grid gap-3">
          {categories.map((category) => (
            <div key={category.id} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
              <div className="flex items-center gap-3">
                <div 
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: category.color }}
                />
                <span className="font-medium text-gray-900">{category.name}</span>
              </div>
              <div className="flex gap-2">
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={() => onEditCategory(category)}
                >
                  <i className="ri-edit-line w-4 h-4 flex items-center justify-center"></i>
                </Button>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => onDeleteCategory(category.id)}
                >
                  <i className="ri-delete-bin-line w-4 h-4 flex items-center justify-center"></i>
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        {categories.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No categories found. Create your first category to organize tasks.
          </div>
        )}
      </div>
    </div>
  );
};